import {NodeFormBuilder} from "../../../../../../../shared/models";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {required, spaceOnName} from "../../../../../../../shared/utils";
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';

export const NODE_TYPE = "fundingSourceConfirm";

/** The FundingSourceConfirmForm.
* It is the flattened version of the step.
* It should contain all the fields that can be changed by the flow-builder.
*/
export interface FundingSourceConfirmForm {
    name: string,
    description: string,
    httpStatus: string,
}

export class FundingSourceConfirm extends NodeFormBuilder<FundingSourceConfirmForm> {

    /**
     * NodeFormBuilder will set up the correct step type.
     */
    constructor() {
        super("integration", NODE_TYPE);
    }

    /**
     * Takes in stepData and returns the flattened version

     * @return FundingSourceConfirmForm
     * @param stepData
     */
    getFromData(stepData: { [index: string]: any }): FundingSourceConfirmForm {

        const integration = stepData?.integration ? stepData?.integration : {};
        const endNode = integration?.endNode ? integration?.endNode : {}

        const outputVars = endNode?.outputVars ? endNode?.outputVars : {}

        return {
            name: this.getValueOrDefault(integration?.name),
            description: this.getValueOrDefault(integration?.description),

            httpStatus: this.getValueOrDefault(outputVars?.httpStatus),
        }
    }

    /**
     * Constructs a FormGroup using the passed in FoobarForm
     * Only users with the correct roll is allowed to edit a flow so fields will be locked.
     *
     * @return FormGroup
     * @param formData
     * @param editFlows
     */
    buildForm(formData: FundingSourceConfirmForm, editFlows: boolean): FormGroup {

        return new FormGroup({
            name: new FormControl({
                value: formData.name,
                disabled: !editFlows,
            }, [required("Name"), spaceOnName()]),
            description: new FormControl({
                value: formData.description,
                disabled: !editFlows,
            }, required("Description")),
            httpStatus: new FormControl({
                value: formData.httpStatus,
                disabled: !editFlows,
            }, required("Http Status")),
        })

    }

    /**
     * Reconstructs the step from the passed in FundingSourceConfirmForm
     *
     * @param nodeData
     */
    setNodeData(nodeData: FundingSourceConfirmForm) {

        const {name, description, httpStatus} = nodeData;

        const outputVars = {
            httpStatus,
        }

        const endNode = {
            endNodeType: NODE_TYPE,
            outputVars
        }

        this.integration = {
            ...this.integration,
            name,
            description,
            integrationType: 'endNode',
            endNode
        }

    }

}

// json: {
//   integration: {
//     name: '',
//     description: '',
//     integrationType: 'endNode',
//     endNode: {
//       endNodeType: 'fundingSourceConfirm',
//       outputVars: {
//         httpStatus: '',
//       },
//     },
//   },
//   type: 'integration',
// },